export const getDistanceLeftToScroll = (element) => {
  return element.scrollHeight - element.scrollTop - element.clientHeight;
};

export const getDistanceLeftToScrollFromWindow = (element) => {
  return (
    element.offsetHeight +
    element.offsetTop -
    window.scrollY -
    window.innerHeight
  );
};

export const getScrollableAmount = (element) =>
  element.scrollHeight - element.offsetHeight;
